module.exports = __webpack_public_path__ + "favicon-32x32.c470c36d.png";